__turbopack_context__.v({
  "container": "classComponent-module__wvawjW__container",
  "image": "classComponent-module__wvawjW__image",
  "img": "classComponent-module__wvawjW__img",
  "innerContainer": "classComponent-module__wvawjW__innerContainer",
});
